import { TextTypeEnum } from '@authority-labs/enums';
import { BaseDto } from './base.dto';

export class TextBank extends BaseDto {
  content?: string;
  type?: TextTypeEnum | string;
  isDefault?: boolean;
  sortOrder?: number;
}
